import { Flex } from '@grupoboticario/flora-react';
import { ExclamationMarkHexagonIcon } from '@grupoboticario/flora-react-icons';
import { theme } from 'ui/theme';

import { NOT_FOUND_BOLETO_CONST, type NotFoundBoletoProps } from './NotFoundBoleto.d';
import { Boleto } from './NotFoundBoleto.style';

const NotFoundBoleto = ({ onClickReload, onClickToHome }: NotFoundBoletoProps) => (
  <Boleto.Component data-testid={NOT_FOUND_BOLETO_CONST.TEST_ID}>
    <Flex justify="center">
      <ExclamationMarkHexagonIcon
        css={{ color: theme.colors.action.nonInteractive.emphasis }}
        size="64"
      />
    </Flex>

    <Boleto.Title level={6} textAlign="center">
      Tivemos um problema para carregar as formas de pagamento
    </Boleto.Title>

    <Boleto.Subtitle textAlign="center">
      Por favor, recarregue a página para tentarmos novamente. Se o problema persistir, recomendamos
      aguardar alguns minutos.
    </Boleto.Subtitle>

    <Boleto.ButtonReload onClick={onClickReload} stretch data-testid="reload-button">
      Recarregar a página
    </Boleto.ButtonReload>

    <Boleto.ButtonToHome onClick={onClickToHome} stretch data-testid="home-button">
      Voltar para o início
    </Boleto.ButtonToHome>
  </Boleto.Component>
);

export default NotFoundBoleto;
